import { useTranslation } from "react-i18next";
import logo from "../assets/LOGO.png";
import {
  StyledHeader,
  HeaderContent,
  LogoContainer,
  TitleContainer,
  RestaurantTitle,
  Logo,
} from "./Header.styled";

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledHeader>
      <HeaderContent>
        <LogoContainer>
          <Logo src={logo} alt={t("header.title")} width={50} height={50} />
        </LogoContainer>
        <TitleContainer>
          <RestaurantTitle>{t("header.title")}</RestaurantTitle>
        </TitleContainer>
      </HeaderContent>
    </StyledHeader>
  );
};

export default Header;
